import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { Fragment } from 'react';
import { useComponents } from 'docz';
import { propEq, get } from 'lodash/fp';
import { MDXProvider } from '@mdx-js/react';
import { useDbQuery } from '../hooks/useDbQuery';
import Wrapper from '../wrapper';
import Theme from '../index';
import SEO from './Seo';
import { jsx as ___EmotionJSX } from "@emotion/core";

const Route = _ref => {
  let {
    children,
    entry,
    isTransclusion
  } = _ref,
      defaultProps = _objectWithoutProperties(_ref, ["children", "entry", "isTransclusion"]);

  const components = useComponents();
  const NotFound = components.notFound;
  const Layout = components.layout;

  const props = _objectSpread(_objectSpread({}, defaultProps), {}, {
    doc: entry
  });

  if (!entry && !isTransclusion) return ___EmotionJSX(NotFound, null);
  return isTransclusion ? children : ___EmotionJSX(MDXProvider, {
    components: components
  }, ___EmotionJSX(Wrapper, null, ___EmotionJSX(Layout, props, children)));
};

const findEntry = (db, ctx) => {
  const isIndex = ctx && ctx.frontmatter && ctx.frontmatter.route === '/';
  const eqIndex = propEq('value.route', '/');
  if (ctx && !ctx.entry && isIndex) return db.entries.find(eqIndex);
  const filepath = get('entry.filepath', ctx);
  return db.entries.find(propEq('value.filepath', filepath));
};

const includesTransclusion = (db, props) => {
  const {
    entries
  } = db;
  const filepath = get('_frontmatter.__filemeta.filename', props);
  return !props.pageContext && entries.includes(entries.find(propEq('value.filepath', filepath)));
};

const Layout = _ref2 => {
  let {
    children
  } = _ref2,
      defaultProps = _objectWithoutProperties(_ref2, ["children"]);

  const {
    pageContext: ctx
  } = defaultProps;
  const db = useDbQuery();
  const entry = findEntry(db, ctx);
  const isTransclusion = includesTransclusion(db, defaultProps);
  return ___EmotionJSX(Fragment, null, entry && ___EmotionJSX(SEO, {
    title: entry.value.name
  }), ___EmotionJSX(Theme, {
    db: db,
    currentEntry: entry
  }, ___EmotionJSX(Route, _extends({}, defaultProps, {
    entry: entry,
    isTransclusion: isTransclusion
  }), children)));
};

export default Layout;

if (typeof Layout !== 'undefined' && Layout && Layout === Object(Layout) && Object.isExtensible(Layout) && !Layout.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Layout, '__filemeta', {
    configurable: true,
    value: {
      name: "Layout",
      filename: "../../node_modules/gatsby-theme-docz/src/base/Layout.js"
    }
  });
}